import React, { Component } from 'react';
import {
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
  IonButton,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonAlert,
  IonSpinner,
  IonBadge,
  IonText,
} from '@ionic/react';

import PublicLinks, { formatDateTime, errorMessage } from '../services/publicLinks';

export default class ReservationManagePage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      token: this.props.match.params.token,
      reservation: null,
      loading: true,
      notFound: false,
      busy: false,
      alert: null,
      error: null,
    };
  }

  async componentDidMount() {
    try {
      const response = await PublicLinks.reservation(this.state.token);
      this.setState({ reservation: response.data, loading: false });
    } catch (error) {
      this.setState({ loading: false, notFound: error?.response?.status === 404, error: errorMessage(error) });
    }
  }

  async run(action) {
    this.setState({ busy: true, error: null });
    try {
      const response = await action(this.state.token);
      this.setState({ reservation: response.data, busy: false });
    } catch (error) {
      this.setState({ busy: false, error: errorMessage(error) });
    }
  }

  statusBadge(r) {
    if (r.status === 'cancelled') return <IonBadge color="medium">Annullata</IonBadge>;
    if (r.is_past) return <IonBadge color="medium">Appuntamento passato</IonBadge>;
    if (r.status === 'pending') return <IonBadge color="warning">In attesa di conferma della farmacia</IonBadge>;
    if (r.attendance_confirmed_at) return <IonBadge color="success">Presenza confermata</IonBadge>;
    return <IonBadge color="primary">Confermata</IonBadge>;
  }

  renderBody() {
    const { reservation: r, loading, notFound, busy, error } = this.state;

    if (loading) return <IonSpinner />;
    if (notFound) return <p>Link non valido o prenotazione non più disponibile.</p>;
    if (!r) return <p>{error}</p>;

    return (
      <IonCard>
        <IonCardHeader>
          <IonCardTitle>{r.service}</IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          <p>{formatDateTime(r.start)}</p>
          <p>{r.shop?.name}</p>
          <p style={{ margin: '12px 0' }}>{this.statusBadge(r)}</p>

          {r.attendance_confirmed_at && (
            <p>Hai confermato la presenza il {formatDateTime(r.attendance_confirmed_at)}.</p>
          )}

          {r.status === 'cancelled' && <p>Questa prenotazione è stata annullata.</p>}

          {error && (
            <IonText color="danger">
              <p>{error}</p>
            </IonText>
          )}

          {r.can_confirm_attendance && (
            <IonButton expand="block" color="success" disabled={busy} onClick={() => this.run(PublicLinks.confirmAttendance)}>
              Confermo la presenza
            </IonButton>
          )}

          {r.can_cancel && (
            <IonButton expand="block" color="danger" fill="outline" disabled={busy} onClick={() => this.setState({ alert: 'cancel' })}>
              Annulla prenotazione
            </IonButton>
          )}

          {!r.can_cancel && r.status !== 'cancelled' && !r.is_past && r.cancel_blocked_reason && (
            <p>
              {r.cancel_blocked_reason}
              {r.shop?.call_number && (
                <>
                  {' '}
                  — <a href={`tel:${r.shop.call_number}`}>{r.shop.call_number}</a>
                </>
              )}
            </p>
          )}
        </IonCardContent>
      </IonCard>
    );
  }

  render() {
    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonTitle>La tua prenotazione</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent className="ion-padding">
          {this.renderBody()}

          <IonAlert
            isOpen={this.state.alert === 'cancel'}
            onDidDismiss={() => this.setState({ alert: null })}
            header="Annullare la prenotazione?"
            message="L'operazione non si può annullare."
            buttons={[
              { text: 'No', role: 'cancel' },
              { text: 'Sì, annulla', handler: () => this.run(PublicLinks.cancelReservation) },
            ]}
          />
        </IonContent>
      </>
    );
  }
}
